export default __webpack_public_path__ + "static/media/appStore.bd744e9e.svg";